export const SET_PAYMENT_METHODS = 'BILLING/SET_PAYMENT_METHODS_DATA'
export const SET_PAYMENT_METHOD_ACTIVE = 'BILLING/SET_PAYMENT_METHOD_ACTIVE'
export const SET_NETWORK_ACCOUNT_DATA = 'BILLING/SET_NETWORK_ACCOUNT_DATA'
export const SET_ACCOUNT_DATA = 'BILLING/SET_ACCOUNT_DATA'
export const GET_NETWORK_ACCOUNT_DATA = 'BILLING/GET_NETWORK_ACCOUNT_DATA'
export const GET_ACCOUNT_DATA = 'BILLING/GET_ACCOUNT_DATA'
export const GET_PAYMENT_METHODS = 'BILLING/GET_PAYMENT_METHODS'
export const TOP_UP = 'BILLING/TOP_UP'
// Нейтральное уведомление об успешном сабмите пополнения. Биллинг просто
// объявляет факт; подписчики (например, онбординг) реагируют независимо.
export const TOP_UP_SUCCESS = 'BILLING/TOP_UP_SUCCESS'
export const RESET_DATA = 'BILLING/RESET_DATA'
export const CALCULATE = 'BILLING/CALCULATE'
export const CALCULATE_ACCOUNTS = 'BILLING/CALCULATE_ACCOUNTS'
export const CALCULATE_ACCOUNT_MARKETPLACE_ORDER =
  'BILLING/CALCULATE_ACCOUNT_MARKETPLACE_ORDER'
export const ACCOUNT_MARKETPLACE_GET_PAYMENT_METHODS =
  'BILLING/ACCOUNT_MARKETPLACE_GET_PAYMENT_METHODS'
export const ACCOUNT_MARKETPLACE_ORDER_PROCESS =
  'BILLING/ACCOUNT_MARKETPLACE_ORDER_PROCESS'
export const SET_DATA_LOADING = 'BILLING/SET_DATA_LOADING'
export const CALCULATE_FEE = 'BILLING/CALCULATE_FEE'
export const DEPOSIT_CREATION_FEE = 'BILLING/DEPOSIT_CREATION_FEE'
export const PUSH_PAYMENT_METHODS = 'BILLING/PUSH_PAYMENT_METHODS'
